import { type LoaderFunctionArgs, redirect } from "react-router";
import type { TransformationRedirectLoaderData } from "src/queries/tfs/tfs.types";
import type { TransformationPath } from "src/utils/appRoutes/appRoutes.types";
import { buildLink } from "src/utils/buildLink/buildLink";
import { fetchOutsideReact } from "src/utils/fetchOutsideReact";

export const transformationRedirectRouterLoader = async (
  args: LoaderFunctionArgs
): Promise<Response> => {
  const res = await fetchOutsideReact<TransformationRedirectLoaderData>({
    url: `/api/tfs/${args.params.tf_id}`,
  });

  const url = new URL(args.request.url);

  return redirect(
    buildLink(
      res.env as string,
      {
        app_name: res.app_name,
        app_pit: res.app_pit,
        task_id: res.task_id,
        tf_id: res.tf_id,
        search: url.searchParams,
      } as TransformationPath
    ) as string
  );
};
